@if (isPageLoading) {
  <ngx-navigation-animation />
}
<main [@fadeAnimation]="getRouterOutletState(o)" class="min-h-screen" style="background-color: var(--color-bg)">
  <router-outlet #o="outlet"></router-outlet>
</main>
<!-- Update available pill — persists until acted on, cannot be displaced by other notifications -->
@if (showUpdatePill && !page.startsWith('/auth')) {
  <div class="fixed bottom-24 md:bottom-6 left-0 right-0 flex justify-center z-50 pointer-events-none px-4">
    <div class="pointer-events-auto pixo-update-pill
                flex items-center gap-x-3 pl-4 pr-2 py-2.5 rounded-2xl
                bg-[#141110] border border-white/10
                shadow-[0_8px_40px_rgba(0,0,0,0.55),0_2px_12px_rgba(0,0,0,0.35)]">
      <mat-icon class="!text-[17px] !size-[17px] text-brand/80 shrink-0">system_update_alt</mat-icon>
      <p class="text-white/80 text-sm font-medium whitespace-nowrap">New version available</p>
      <button (click)="refreshPage()"
              class="ml-1 px-3.5 py-1.5 rounded-full bg-brand text-white text-xs font-semibold
                     hover:bg-brand/85 transition-colors whitespace-nowrap">
        Refresh
      </button>
      <button (click)="dismissUpdatePill()"
              class="w-7 h-7 rounded-full bg-white/8 hover:bg-white/15 flex items-center justify-center transition-colors shrink-0">
        <mat-icon class="!text-[12px] !size-[12px] text-white/50">close</mat-icon>
      </button>
    </div>
  </div>
}

<!--Raise the pages the tawk FAB wont conflict with page elements-->
<div id="tawkFABRaiser" class="h-24" style="background-color: var(--color-bg)"
     [hidden]="page.startsWith('/auth')"></div>